import { useEffect } from 'react';

import { prefetchAppShell } from '@/lib/prefetch-app-shell';

/**
 * Warm the post-login route chunks while the login page is idle, so the first
 * navigation after sign-in renders from cache. Mount this on the web login view.
 *
 * @param enabled - gate the warm; pass `!isLoading` so an in-flight sign-in/MFA
 *   request cancels the not-yet-started stage and doesn't contend with the auth
 *   round-trip. Effect cleanup disposes the pending idle callback on unmount.
 */
export function usePrefetchAppShell(enabled = true): void {
  useEffect(() => {
    if (!enabled) {
      return;
    }
    return prefetchAppShell();
  }, [enabled]);
}
